var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropboxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0L29 7.5L14.5 15L0 7.5L14.5 0Z",
    fill: "#0061FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5L14.5 15L0 22.5L14.5 15L0 7.5Z",
    fill: "#0061FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 7.5L14.5 15L29 22.5L14.5 15L29 7.5Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxIcon);
export default __webpack_public_path__ + "static/media/dropbox-icon.b7bd14887218d6f460237aa713003e0d.svg";
export { ForwardRef as ReactComponent };